import React, { useState, useEffect } from 'react';
import { Table } from 'rsuite';
import {
  DndContext,
  closestCenter,
  useSensor,
  useSensors,
  MouseSensor,
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';

import { SortableItem } from '../../atoms/sortableItem/sortableItem';
import { default as t } from '../../../utils/i18n';

import './campaing-performance.scss';
const { Column, HeaderCell, Cell } = Table;

function CampaingPerformance(props) {
  const [tableData, setTableData] = useState([]);
  const [panels, setPanels] = useState([]);
  useEffect(() => {
    const lastCycle = props?.data?.lastCycleData?.metrics_total;
    const currentCycle = props?.data?.reportData?.metrics_total;
    const kpiList = props?.kpiList?.length > 0 ? props?.kpiList : [];
    const cycleData = [];
    currentCycle?.forEach(el => {
      let row = {};
      row.metric = kpiList?.filter(x => x?.sys_id === el?.key)[0]?.KPI_Metric;
      const currentvalue = el.value.trim();
      row.current_cycle = currentvalue && convertValue(currentvalue)|| 'N/A';
      const lastCycleValue = lastCycle.filter(x => x?.key === el?.key)[0]?.value;
      row.last_cycle = lastCycleValue && convertValue(lastCycleValue) || 'N/A';
      row.percent =
        (row.last_cycle === 'N/A' || row.current_cycle === 'N/A' || lastCycleValue === '0.00')
          ? 'N/A'
          : (((currentvalue - lastCycleValue) / lastCycleValue) * 100).toFixed(2) + '%';
      cycleData.push(row);
    });
    setTableData(cycleData);
    let commentary = [];
    props?.data?.reportData?.last_vs_current_commentary_to_show?.forEach((list, index) =>
      commentary.push({
        id: index,
        content: list.value,
        editable: false,
        show_in_export: list.show_in_export,
      })
    );
    setPanels([...commentary]);
  }, []);

  const convertValue = (value) => {
    return Number(value)?.toLocaleString();
  }
  const MultiplePanels = () => {
    const mouseSensor = useSensor(MouseSensor, {
      activationConstraint: {
        distance: 10, // Enable sort function when dragging 10px   💡 here!!!
      },
    });
    const sensors = useSensors(mouseSensor);
    function handleDragEnd(event) {
      const { active, over } = event;

      if (active.id !== over.id) {
        const oldIndex = panels.findIndex(x => x.id === active.id);
        const newIndex = panels.findIndex(x => x.id === over.id);
        const newArray = arrayMove(panels, oldIndex, newIndex);
        updatePanelsData(newArray);
      }
    }

    const updatePanelsData = (comentryData, type = '') => {
      console.log(comentryData);
      setPanels(comentryData);
      if (type !== 'edit') {
        props?.updateReportPreference('last_vs_current_commentary', comentryData);
      }
    };

    return (
      <>
        {props?.isEdit ? (
          <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragEnd={handleDragEnd}
            autoScroll={false}
          >
            <SortableContext items={panels} strategy={verticalListSortingStrategy}>
              {panels.map(item => (
                <SortableItem
                  data={item}
                  isEdit={props?.isEdit}
                  panels={panels}
                  fromSnapShot={props?.fromSnapShot}
                  setPanels={(data, type) => updatePanelsData(data, type)}
                />
              ))}
            </SortableContext>
          </DndContext>
        ) : (
          <div>
            {panels.map(item =>
              !item?.show_in_export && props?.fromSnapShot ? (
                ''
              ) : (
                <SortableItem
                  data={item}
                  isEdit={props?.isEdit}
                  panels={panels}
                  setPanels={(data, type) => updatePanelsData(data, type)}
                />
              )
            )}
          </div>
        )}
      </>
    );
  };
  return (
    <div className="final-report-main-container">
      <div className="table-Box">
        <Table
          bordered
          width={900}
          data={tableData}
          autoHeight
          onRowClick={rowData => {
            console.log(rowData);
          }}
          wordWrap={props?.fromSnapShot}
        >
          <Column width={300}>
            <HeaderCell>{t('final.output.metric')}</HeaderCell>
            <Cell>
              {rowData => {
                return <span className={rowData?.metric === 'N/A' ? 'notAvailableText':''} title={rowData?.metric}>{rowData?.metric}</span>;
              }}
            </Cell>
          </Column>

          <Column width={200}>
            <HeaderCell align='right'>{t('final.output.current.cycle')}</HeaderCell>
            <Cell align='right'>
              {rowData => {
                return <span className={rowData?.current_cycle === 'N/A' ? 'notAvailableText':''} title={rowData?.current_cycle}>{rowData?.current_cycle}</span>;
              }}
            </Cell>
          </Column>

          <Column width={200}>
            <HeaderCell align='right'>{t('final.output.last.cycle')}</HeaderCell>
            <Cell align='right'>
              {rowData => {
                return <span className={rowData?.last_cycle === 'N/A' ? 'notAvailableText':''} title={rowData?.last_cycle}>{rowData?.last_cycle}</span>;
              }}
            </Cell>
          </Column>
          <Column width={200}>
            <HeaderCell align='right'>{t('final.output.percentage.diff')}</HeaderCell>
            <Cell align='right'>
              {rowData => {
                return <span className={rowData?.percent === 'N/A' ? 'notAvailableText':''} title={rowData?.percent}>{rowData?.percent}</span>;
              }}
            </Cell>
          </Column>
        </Table>
      </div>
      {panels?.length > 0 ? (
        <div className="insights">
          <h3>{t('final.output.insights.title')}</h3>
          <MultiplePanels />
          <div className='the-insights'><span className='high-light'>*</span>{t('report.output.insights.note')} </div>
        </div>
      ) : (
        <div className="insights">
        <h3>{t('final.output.insights.title')}</h3>
        <p className='no-insights'>{t('final.output.no.insights')}</p>
        </div>
      )}
    </div>
  );
}
export default CampaingPerformance;
